import {combineReducers, configureStore} from "@reduxjs/toolkit";
import {userAPI} from "./services/UserService";
import {categoryAPI} from "./services/CategoryService";
import {publicationAPI} from "./services/PublicationService";
import {fileAPI} from "./services/FileService";


const rootReducer = combineReducers({
    [userAPI.reducerPath]: userAPI.reducer,
    [categoryAPI.reducerPath]: categoryAPI.reducer,
    [publicationAPI.reducerPath]: publicationAPI.reducer,
    [fileAPI.reducerPath]: fileAPI.reducer,
})

export const setupStore = () => {
    return configureStore({
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware().concat(
                userAPI.middleware,
                categoryAPI.middleware,
                publicationAPI.middleware,
                fileAPI.middleware
            )
    })
}

export type RootState = ReturnType<typeof rootReducer>
export type AppStore  = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch']